import { Helmet } from 'react-helmet-async';


export  const SEOProductDetail = ({ product }) => {
    const productName = product?.name || "X-Ray";
    const productDescription = product?.description || "Unimax X-Ray";
    const productImage = product?.image || "https://x-ray.co.id/default-image.jpg";
    const productURL = `https://x-ray.co.id/product/${product?.slug || "default"}`;

    return (
        <Helmet>
            <title>Unimax X-Ray {productName}</title>
            <meta name="description" content={`Unimax,${productName}, X-Ray, Unimax ${productName}, xray, unimax xray, xray ${productName} Unimax X-Ray,`} />
            <meta
                name="keywords"
                content={`Unimax,${productName}, X-Ray, Unimax ${productName}, xray, unimax xray, xray ${productName} Unimax X-Ray, Unitek `}
            />
            <meta name="author" content="PT Unitek Solusi Indonesia" />
            <meta property="og:title" content={`Unimax - ${productName}`} />
            <meta property="og:description" content={`${productDescription}`} />
            <meta property="og:image" content={productImage} />
            <meta property="og:url" content={productURL} />
            <meta property="og:type" content="website" />
            <link rel="canonical" href={productURL} />
        </Helmet>
    );
};


export  const HomeSEO = () => {
    return (
        <Helmet>
            <title>Unimax X-Ray - Mesin X-Ray Akurat & Andal</title>
            <meta
                name="description"
                content="Unimax Xray adalah brand global yang menyediakan solusi teknologi modern seperti Metal Detector, Checkweigher, X-Ray, dan Optical Sorting System untuk berbagai industri dengan kualitas tinggi dan performa andal."
            />
            <meta
                name="keywords"
                content={`Unimax, X-Ray, X-Ray Indonesia, Unitek X-Ray, Unimax X-Ray, Unitek, xray, unimax xray, xray unimax `}
            />
            <meta name="author" content="PT Unitek Solusi Indonesia" />
            <meta property="og:title" content="Unimax - Solusi Teknologi Modern untuk Industri" />
            <meta
                property="og:description"
                content="Unimax adalah brand global yang menyediakan solusi teknologi modern seperti Metal Detector, Checkweigher, X-Ray, dan Optical Sorting System untuk berbagai industri dengan kualitas tinggi dan performa andal."
            />
            <meta property="og:image" content="https://x-ray.co.id/default-home-image.jpg" />
            <meta property="og:url" content="https://x-ray.co.id/" />
            <meta property="og:type" content="website" />
            <link rel="canonical" href="https://x-ray.co.id/" />
        </Helmet>
    );
};


export  const CatalogSEO = () => {
    return (
        <Helmet>
            <title>Unimax - Katalog X-Ray</title>
            <meta
                name="description"
                content="Katalog Unimax X-Ray, Unimax, X-Ray, X-Ray Indonesia, Unitek X-Ray, Unimax X-Ray, Unitek, xray, unimax xray, xray unimax ."
            />
            <meta
                name="keywords"
                content={`Unimax, X-Ray, X-Ray Indonesia, Unitek X-Ray, Unimax X-Ray, Unitek, xray, unimax xray, xray unimax `}
            />
            <meta name="author" content="PT Unitek Solusi Indonesia" />
            <meta property="og:title" content="Unimax - Katalog X-Ray" />
            <meta
                property="og:description"
                content="Lihat katalog lengkap X-Ray Unimax "
            />
            <meta property="og:image" content="https://x-ray.co.id/catalog-image.jpg" />
            <meta property="og:url" content="https://x-ray.co.id/catalog" />
            <meta property="og:type" content="website" />
            <link rel="canonical" href="https://x-ray.co.id/catalog" />
        </Helmet>
    );
};


export  const AboutSEO = () => {
    return (
        <Helmet>
            <title>Unimax X-Ray</title>
            <meta
                name="description"
                content="Unimax Xray adalah global brand yang berfokus pada teknologi modern dengan integrasi produksi, penelitian, pengembangan, penjualan, dan layanan. Kami menyediakan solusi pengujian canggih untuk berbagai industri, termasuk makanan, obat-obatan, dan bahan kimia."
            />
            <meta
                name="keywords"
                content={`Unimax, X-Ray, X-Ray Indonesia, Unitek X-Ray, Unimax X-Ray, Unitek, xray, unimax xray, xray unimax `}
            />
            <meta name="author" content="PT Unitek Solusi Indonesia" />
            <meta property="og:title" content="Unimax - Tentang Checkweigher" />
            <meta
                property="og:description"
                content="Unimax Xray adalah global brand yang berfokus pada teknologi modern dengan integrasi produksi, penelitian, pengembangan, penjualan, dan layanan. Kami menyediakan solusi pengujian canggih untuk berbagai industri, termasuk makanan, obat-obatan, dan bahan kimia."
            />
            <meta property="og:image" content="https://x-ray.co.id/about-image.jpg" />
            <meta property="og:url" content="https://x-ray.co.id" />
            <meta property="og:type" content="website" />
            <link rel="canonical" href="https://x-ray.co.id" />
        </Helmet>
    );
};



export const AddressSEO = () => {
    return (
        <Helmet>
            <title>Unimax X-Ray</title>
            <meta
                name="description"
                content="Bizlink Citra Raya Jl. Pemda Tigaraksa No.106 Blok P03, Tangerang Regency, Banten 15710"
            />
            <meta
                name="keywords"
                content="Bizlink, Bizlink Citra Raya Jl. Pemda Tigaraksa No.106 Blok P03, Tangerang Regency, Banten 15710, Citra Raya, Xray Tangerang Unimax, Xray, Xray Indonesia, Unitek Xray, Unimax Xray, Unitek, Unimax, X-Ray, X-Ray Indonesia, Unitek X-Ray, Unimax X-Ray, Unitek, xray, unimax xray, xray unimax "
            />
            <meta name="author" content="PT Unitek Solusi Indonesia" />
            <meta property="og:title" content="Alamat - Unimax X-Ray" />
            <meta
                property="og:description"
                content="Unimax Xray adalah global brand yang berfokus pada teknologi modern dengan integrasi produksi, penelitian, pengembangan, penjualan, dan layanan. Kami menyediakan solusi pengujian canggih untuk berbagai industri, termasuk makanan, obat-obatan, dan bahan kimia."
            />
            <meta property="og:image" content="https://x-ray.co.id/about-image.jpg" />
            <meta property="og:url" content="https://x-ray.co.id" />
            <meta property="og:type" content="website" />
            <link rel="canonical" href="https://x-ray.co.id" />
        </Helmet>
    );
};
